module.exports = __webpack_public_path__ + "img/upbit.9d711d15.svg";